import { createBasicCourseRegistry } from "./basicCourseCatalog";
import { getBasicCourseCatalog } from "./basicCourseMetadata";

export function createCombinatoricsExamRegistry(fallbackRegistry) {
  const officialRegistry = createBasicCourseRegistry(fallbackRegistry);
  const registry = { ...fallbackRegistry };
  getBasicCourseCatalog().forEach((entry, type) => {
    if (entry.kind !== "closed" || !entry.codes.some(code => /^9\.1\.[1-4]$/.test(code))) return;
    const official = officialRegistry[type];
    registry[type] = { ...official,
      generateTask: meta => meta?.combinatoricsSource
        ? official.generateTask(meta)
        : fallbackRegistry[type]?.generateTask?.(meta) || official.generateTask(meta),
    };
  });
  return registry;
}
